<template>
    <footer class="bg-white border-gray-200 dark:bg-custom-green-50">
        <div class="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between">
            <span class="text-sm text-black sm:text-center dark:text-white">
                IsaiBCastro © {{ new Date().getFullYear() }}
                <RouterLink to="/" class="hover:underline">PRODESSA</RouterLink>. Todos los derechos reservados.
            </span>
            <nav>
                <ul class="flex flex-wrap items-center mt-3 text-sm font-medium text-black dark:text-white sm:mt-0">
                    <li>
                        <RouterLink to="/about" class="hover:underline me-4 md:me-6" aria-label="About Us">Sobre
                            Nosotros
                        </RouterLink>
                    </li>
                    <li>
                        <RouterLink to="/about" class="hover:underline me-4 md:me-6"
                            aria-label="Privacy Policy">Politicas de
                            Privacidad</RouterLink>
                    </li>
                    <li>
                        <RouterLink to="/contact" class="hover:underline me-4 md:me-6" aria-label="Contact Us">
                            Contáctanos
                        </RouterLink>
                    </li>
                </ul>
            </nav>
        </div>
    </footer>
</template>

<script setup>
import { RouterLink } from 'vue-router';
</script>

<style scoped>
</style>
